import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { staffApi, getStoredUser, isSessionExpired, saveSession, clearSession } from "@/lib/staffApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => (isSessionExpired() ? null : getStoredUser()));
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        if (!user) { setChecking(false); return; }
        // Verify token is still valid on the server.
        staffApi.me()
            .then((u) => setUser(u))
            .catch(() => { clearSession(); setUser(null); })
            .finally(() => setChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const login = useCallback(async (email, password) => {
        const res = await staffApi.login(email, password);
        saveSession(res);
        setUser(res.user);
        return res.user;
    }, []);

    const logout = useCallback(async () => {
        await staffApi.logout();
        setUser(null);
    }, []);

    const value = useMemo(() => ({ user, checking, login, logout }), [user, checking, login, logout]);
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth outside AuthProvider");
    return ctx;
}
